<template>
    <div
        :class="['bo-tab tab']"
        v-if="visible"
    >
        <div class="bo-tab-title">
            <ul
                class="bo-nav nav nav-tabs"
                role="tablist"
            >
                <li
                    class="nav-item"
                    v-for="tab in tabs"
                    :key="tab.id"
                >
                    <a
                        @click="select(tab)"
                        :class="['nav-link', { active: selected == tab.id }]"
                    >
                        <span
                            v-if="tab.showDot"
                            :style="{
                                backgroundColor: tab.color,
                            }"
                            class="tab-dot"
                        ></span>
                        {{ tab.title }}
                        <span
                            :class="['badge', { dangerBadge: colour == true && selected == tab.id}]"
                            v-if="tab.counter !== undefined && tab.counter !== null"
                            >{{ tab.counter }}</span
                        >
                        <i
                            v-if="canRemove && selected == tab.id"
                            class="icon-close"
                            @click="removeTab(tab.id)"
                        ></i>
                    </a>
                    <!-- <button
                        v-if="editable"
                        class="btn-rounded dashed arclight btn-add col-12"

                    >
                    </button> -->
                </li>
                <li
                    v-if="editable"
                    class="nav-item-add"
                >
                    <i
                        class="icon-addcircle"
                        @click="addTab"
                    ></i>
                    <!-- <button class="btn-rounded dashed arclight btn-add col-12" >
                    </button> -->
                </li>
            </ul>
            <slot name="tabs-right"></slot>
            <!-- SEARCH -->
            <div
                v-if="hasSearch"
                class="searchbar ml-2"
            >
                <a
                    href=""
                    class="btn-search"
                >
                    <i class="icon-search"></i>
                </a>
                <input
                    type="text"
                    class="search-input"
                    placeholder="Search"
                />
            </div>
        </div>
        <div class="tab-content">
            <div
                v-for="tab in tabs"
                :class="['tab-pane fade show', { active: selected == tab.id }]"
                :key="tab.id"
            >
                <slot
                    :name="`${tab.id}_content`"
                    :tabs="tabs"
                    :tab="tab"
                ></slot>
                <slot
                    :name="'content'"
                    :tab="tab"
                ></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: [Array, Object],
            default: [],
        },
        default: {
            type: [String, Number],
            default: null,
        },
        hasSearch: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        // controls the per-tab remove ("x") icon independently of the add ("+") button
        // gated by `editable`; defaults to `editable` so existing consumers are unaffected
        removable: {
            type: Boolean,
            default: null,
        },
        color: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: "default",
        event: "change",
    },
    data() {
        return {
            selected: this.default,
            colour: this.color,
        };
    },
    watch: {
        default: function (n, o) {
            this.selected = n;
        },
    },
    mounted() {
        if (this.selected == null) {
            if (Array.isArray(this.tabs) && this.tabs.length) {
                this.select(this.tabs[0]);
            } else {
                const values = Object.values(this.tabs);
                if (values.length) {
                    this.select(values[0]);
                }
            }
        }
    },
    computed: {
        canRemove() {
            return this.removable ?? this.editable;
        },
    },
    methods: {
        select(item) {
            this.selected = item.id;
            this.$emit("change", item.id);
            this.$emit("selected_tab", item.title);
        },
        addTab() {
            this.$emit("add");
        },
        removeTab(id) {
            this.$emit("remove", id);
        },
    },
};
</script>
